import { ServiceIntegration } from 'data/terra/ServiceIntegration';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import Terra from 'services/apis/terra/Terra';
import { RootState } from 'store/reducer';
import {
  FetchResourceAction,
  fetchResourceDelegate,
  Resource,
  ResourceActionTypes,
} from 'v2/store/common/Resource';
import { ProjectDetailState } from '../state';

const ActionTypes: ResourceActionTypes = {
  requestFetching: 'project/serviceIntegrations/fetch',
  fetchSuccess: 'project/serviceIntegrations/fetchSuccess',
  fetchFailure: 'projectt/serviceIntegrations/fetchFailure',
};

export type FetchServiceIntegrationsAction = FetchResourceAction<
  ServiceIntegration[]
>;

export const fetchServiceIntegrationsForCurrentVersion = (): ThunkAction<
  void,
  RootState,
  unknown,
  Action<string>
> => async (dispatch, getState) => {
  const selectedApp = getState().projectDetail.selectedApp;
  const selectedAppVersion = getState().projectDetail.selectedAppVersion;

  if (selectedApp && selectedAppVersion) {
    dispatch(fetchServiceIntegrations(selectedApp.id, selectedAppVersion.id));
  }
};

const fetchServiceIntegrations = (
  appId: string,
  appVersionId: string
): ThunkAction<void, RootState, unknown, Action<string>> => async dispatch => {
  dispatch({
    type: ActionTypes.requestFetching,
  } as FetchServiceIntegrationsAction);

  const result = await Terra.serviceIntegration.fetchServiceIntegrations(
    appId,
    appVersionId
  );

  if (result.isSuccess()) {
    dispatch({
      type: ActionTypes.fetchSuccess,
      data: result.get()!.data,
    } as FetchServiceIntegrationsAction);
  } else {
    dispatch({
      type: ActionTypes.fetchFailure,
      error: result.exception(),
    } as FetchServiceIntegrationsAction);
  }
};

export const fetchServiceIntegrationsDelegate = fetchResourceDelegate<
  ProjectDetailState,
  ServiceIntegration[]
>(
  ActionTypes,
  (
    rootState: ProjectDetailState,
    reduce: (
      state: Resource<ServiceIntegration[]>
    ) => Resource<ServiceIntegration[]>
  ) => {
    return {
      ...rootState,
      serviceIntegrations: reduce(rootState.serviceIntegrations),
    };
  }
);
